import { useTranslation } from "react-i18next"
import { FaExternalLinkAlt } from "react-icons/fa"
import { NeutralButton } from "../../common/Buttons"

export default function TxnTitleTrackingLinks({ units }) {
  const { t } = useTranslation()
  const unitsWithTrackingLinks = units.filter((unit) => unit.title_tracking_link)
  const showVin = units.length > 1

  return unitsWithTrackingLinks.map((unit) => (
    <div key={`title-${unit.vin}`} className="mt-2 mr-4">
      {showVin &&
        <div className="text-sm text-grey-300 mb-1">{unit.vin}</div>
      }
      <NeutralButton
        text={<span className="flex items-center gap-2">{t('Track Title')} <FaExternalLinkAlt /></span>}
        onClick={() => window.open(unit.title_tracking_link, '_blank')}
      />
    </div>
  ))
}
